// src/api/bookPricesApi.js
import axios from "axios";

const BASE = `${process.env.REACT_APP_SERVER_URL}/api/bookPrices`;

/** Fetch all book prices (public, no auth). */
export async function fetchBookPrices() {
    const { data } = await axios.get(BASE);
    return data;
}

/** Fetch admin status with per-book details (requires admin auth). */
export async function fetchBookPriceStatus(token) {
    const { data } = await axios.get(`${BASE}/status`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return data;
}

/** Trigger a manual price refresh (requires admin auth). */
export async function triggerPriceRefresh(token) {
    const { data } = await axios.post(
        `${BASE}/refresh`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}

/** Manually set a book price (requires admin auth). */
export async function updateBookPrice(bookId, price, token) {
    const { data } = await axios.patch(
        `${BASE}/${bookId}`,
        { price },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
}
